import MobileLayersPanel from "components/MobileLayersPanel";
import MapPane from "components/MapPane";
import MapNavigationBar from "components/MapNavigationBar";
import Sidebar from "components/Sidebar/Sidebar";
import fetchContent from "lib/api/fetchContent";
import MapControlsToolbars from "components/MapControlsToolbars/Desktop";
import apiData from "lib/stores/apiData";
import useSyncURLHash from "lib/hooks/useSyncURLHash";
import useProcessURLHash from "lib/hooks/useProcessURLHash";
import { useEffect } from "react";
import { useSnapshot } from "valtio";
import { useResizeListener } from "lib/hooks/useResizeListener";

const Home = () => {
  const { fetchingTopLevelData } = useSnapshot(apiData);

  // Initial Data Fetch
  useEffect(() => {
    fetchContent();
  }, []);

  // Set the URL Hash to reflect the latest state changes
  useSyncURLHash();

  // Listen for a change to the url hash, and run the appropriate action(s)
  useProcessURLHash();

  // Listen for a change to the window size, and update the map size, and the position of the sidebar and map controls
  useResizeListener();

  return (
    <>
      <main className="overflow-hidden">{fetchingTopLevelData ? <Loading /> : <Main />}</main>
    </>
  );
};

const Main = () => {
  return (
    <>
      <Sidebar />
      <div className="panel--wrapper">
        <MapNavigationBar />
        <MapPane />
      </div>
      <MapControlsToolbars />
      <MobileLayersPanel />
    </>
  );
};

const Loading = () => {
  return <div className="w-full font-bold rubik h-screen flex items-center justify-center bg-gray-200 animate-pulse">LOADING</div>;
};

export default Home;
